import React, { useState } from "react";
import { X, KeyRound, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function ReAuthModal({ open, scope, title, onSuccess, onClose, ownerHasTotp = true }) {
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open) return null;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reauth", { password, totp_code: totp || null, scope });
      toast.success("Yeniden doğrulama başarılı");
      onSuccess(data.reauth_token);
      setPassword(""); setTotp("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Doğrulama başarısız");
    } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="reauth-modal">
      <form onSubmit={submit} className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 relative">
        <button type="button" onClick={onClose} className="absolute top-3 right-3 text-stone-400 hover:text-stone-700" data-testid="reauth-close"><X className="w-5 h-5" /></button>
        <div className="flex items-center gap-2 mb-3"><ShieldCheck className="w-5 h-5 text-amber-700" /><h2 className="font-serif-display text-xl">Yeniden Doğrulama</h2></div>
        <p className="text-xs text-stone-500 mb-4">{title || "Bu kritik işlem için şifrenizi ve Authenticator kodunuzu tekrar girin."}</p>
        <label className="block text-xs font-semibold uppercase tracking-wider text-stone-500 mb-2">Şifre</label>
        <input data-testid="reauth-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mb-3 px-3 py-2 rounded-lg border border-stone-200 outline-none focus:border-amber-500" autoFocus />
        {ownerHasTotp && (
          <>
            <label className="block text-xs font-semibold uppercase tracking-wider text-stone-500 mb-2">Authenticator kodu</label>
            <input data-testid="reauth-totp" value={totp} onChange={(e) => setTotp(e.target.value.replace(/\D/g, "").slice(0, 6))} inputMode="numeric" placeholder="123456" className="w-full mb-4 px-3 py-2 rounded-lg border border-stone-200 outline-none focus:border-amber-500 tracking-[0.4em] text-center" />
          </>
        )}
        <div className="flex gap-2">
          <button type="button" onClick={onClose} className="flex-1 py-2 rounded-lg border border-stone-200 text-sm">İptal</button>
          <button data-testid="reauth-submit" type="submit" disabled={busy || !password} className="flex-1 py-2 rounded-lg gold-gradient text-white text-sm disabled:opacity-60">{busy ? "Doğrulanıyor..." : "Devam Et"}</button>
        </div>
      </form>
    </div>
  );
}
